import { useMemo } from "react";

import AttachedCloudIntegrationsSection from "components/AttachCloud/Details/CloudIntegrationsSection";
import Box from "ds/components/Box";
import useTypedContext from "hooks/useTypedContext";
import { CLOUD_INTEGRATION_CONFIG } from "shared/CloudIntegration/constants";

import useAttachedCloudIntegration from "../AttachCloud/hooks/useAttachedCloudIntegration";
import { ModuleFormContext } from "../context";
import { ModuleCreationWizardStep } from "../types";
import NewModuleSummaryPanel from "./Panel";

type NewModuleSummaryCloudProps = {
  title: string;
  goToStepDisabled?: boolean;
  createdModuleId: string;
};

const cloudConfig = [
  CLOUD_INTEGRATION_CONFIG.AWS,
  CLOUD_INTEGRATION_CONFIG.Azure,
  CLOUD_INTEGRATION_CONFIG.GCP,
];

const NewModuleSummaryCloud = ({
  title,
  goToStepDisabled,
  createdModuleId,
}: NewModuleSummaryCloudProps) => {
  const { formData } = useTypedContext(ModuleFormContext);
  const moduleLabels = useMemo(
    () => formData[ModuleCreationWizardStep.Details].labels.map((item) => item.value),
    [formData]
  );
  const { manuallyAttachedIntegrations, autoAttachedIntegrations, loading, hasData, refetch } =
    useAttachedCloudIntegration(createdModuleId);

  return (
    <NewModuleSummaryPanel
      name={title}
      step={ModuleCreationWizardStep.Cloud}
      goToStepDisabled={goToStepDisabled}
      fullbleed
    >
      {!loading && hasData && (
        <Box direction="column" gap="x-large">
          <AttachedCloudIntegrationsSection
            title="Attached directly"
            integrations={manuallyAttachedIntegrations}
            cloudConfig={cloudConfig}
            stackId={createdModuleId}
            readOnly={false}
            onSuccessDetach={refetch}
            stackLabels={moduleLabels}
          />
          <AttachedCloudIntegrationsSection
            title="Auto-attached"
            integrations={autoAttachedIntegrations}
            cloudConfig={cloudConfig}
            stackId={createdModuleId}
            readOnly={true}
            isAutoAttached={true}
            stackLabels={moduleLabels}
          />
        </Box>
      )}
    </NewModuleSummaryPanel>
  );
};

export default NewModuleSummaryCloud;
